import React from 'react';
import styled from 'styled-components';

interface StyleProps {
  size: number;
  color: string;
}

interface Props {
  color?: string;
  size?: number;
  title: string;
}

const H6 = ({ color = '#000', size = 12, title }: Props) => {
  return (
    <H6Style color={color} size={size}>
      {title}
    </H6Style>
  );
};

export default H6;

/* styles */
const H6Style = styled.h6<StyleProps>`
  font-size: ${({ size }) => `${size}px`};
  color: ${({ color }) => color};
`;
